// Action Types
export const Types = {
    LIST_USER: 'LIST_USER',
    LIST_USER_SUCCESS: 'LIST_USER_SUCCESS',
    LIST_USER_BY_ID: 'LIST_USER_BY_ID',
    LIST_USER_BY_ID_SUCCESS: 'LIST_USER_BY_ID_SUCCESS',
    UPDATE_USER:'UPDATE_USER',
    UPDATE_USER_SUCCESS:'UPDATE_USER_SUCCESS',
    UPDATE_USER_LOADING:'UPDATE_USER_LOADING',
    REMOVE_USER: 'REMOVE_USER',
    REMOVE_USER_SUCCESS: 'REMOVE_USER_SUCCESS',
    CREATE_USER: 'CREATE_USER',
    CREATE_USER_SUCCESS: 'CREATE_USER_SUCCESS'
}

const DEFAULT_LIST_PARAMS = {
    page: 1,
    limit: 10,
    sort: 'name',
    order: 'asc'
}

// Reducer
const INITIAL_STATE = {
    users: [],
    user: {},
    pagination: {
        totalItems: 0,
        totalPages: 0,
        itemsPerPage: 10,
        currentPage: 1,
    },
    listParams: DEFAULT_LIST_PARAMS,
    isLoading: false
}

export default function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case Types.LIST_USER:
            return {
                ...state,
                listParams: {
                    ...state.listParams,
                    ...action.payload
                }
            }
        case Types.LIST_USER_SUCCESS:
            return {
                ...state,
                users: action.payload.users,
                pagination: action.payload.pagination
            }
        case Types.UPDATE_USER_LOADING:
            return {
                ...state,
                isLoading: action.payload
            }
        default:
            return state;
    }
}

// Action Creators
export const listUser = (params = {}) => {
    return {
        type: Types.LIST_USER,
        payload: params
    }
}

export const listUserSuccess = (users, pagination) => {
    return {
        type: Types.LIST_USER_SUCCESS,
        payload: { users, pagination }
    }
}

export const updateUserLoading = (isLoading) => {
    return {
        type: Types.UPDATE_USER_LOADING,
        payload: isLoading
    }
}

export const createUser = (data) => {
    return {
        type: Types.CREATE_USER,
        payload: data
    }
}

export const removeUser = (id) => {
    return {
        type: Types.REMOVE_USER,
        payload: id
    }
}

export const updateUser = (user) => {
    return {
        type: Types.UPDATE_USER,
        payload: user
    }
}
